import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {CanalOperadorModel} from '../../../shared/model/canal/canal-operador.model';
import {HorasMinutosPipe} from '../../../shared/pipe/horas-minutos.pipe';
import {OperadorAtendimentoModel} from '../../../shared/model/usuario/operador-atendimento.model';
import {NgClass} from '@angular/common';
import {environment} from '../../../../../environments/environment';
import {DomSanitizer} from '@angular/platform-browser';
import {AuthService} from '../../../shared/service/auth.service';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'app-info-cainais-operadores',
  standalone: true,
  imports: [
    HorasMinutosPipe,
    NgClass,
    MatTooltip
  ],
  templateUrl: './info-cainais-operadores.component.html',
  styleUrl: './info-cainais-operadores.component.css'
})
export class InfoCainaisOperadoresComponent {
  @Input() canaisOperadores?: CanalOperadorModel;
  @Input() isMobile = false;
  @Output() operadorEscolhido = new EventEmitter<{ operadorAtendimento: OperadorAtendimentoModel, canalId: number }>();
  operadorSelecionado?: OperadorAtendimentoModel;

  private readonly domSanitizer = inject(DomSanitizer);
  private readonly authService = inject(AuthService);

  selecionarOperador(operador: OperadorAtendimentoModel, canalId: number) {
    this.operadorSelecionado = operador;
    this.operadorEscolhido.emit({
      operadorAtendimento: this.operadorSelecionado,
      canalId: canalId
    });
  }

  gerarUrl(nomeArquivo: string, extensao: string, path: string) {
    return this.domSanitizer.bypassSecurityTrustUrl(`${environment.urlRepositorioClaribot}/${this.authService.getUsuarioLogado().grupo}/${path}/${nomeArquivo}.${extensao}`);
  }

  protected readonly Math = Math;
}
